import { BaseModal, FormActions, FormField, FormInput } from '@practium/ui';
import { useIncompleteParamsForm } from '../../hooks/useIncompleteParamsForm';
import type { IncompleteParam, ReferenceUpdate, StateReferenceDTO } from '../../types/parameters.types';
import styles from './Sections.module.css';

interface IncompleteParamsModalProps {
	reference: StateReferenceDTO;
	params: IncompleteParam[];
	isSaving: boolean;
	onClose: () => void;
	onSubmit: (update: ReferenceUpdate) => Promise<boolean>;
}

export const IncompleteParamsModal = ({ reference, params, isSaving, onClose, onSubmit }: IncompleteParamsModalProps) => {
	const { rows, errors, setField, submit } = useIncompleteParamsForm({ reference, params, onSubmit, onClose });

	return (
		<BaseModal
			isOpen
			wide
			title="Completar cadastro do solo"
			subtitle="Preencha os dados de todos os parâmetros para liberar o salvamento das regras do solo."
			isLoading={isSaving}
			onClose={onClose}
			actions={<FormActions onCancel={onClose} onSave={submit} isLoading={isSaving} saveText="Salvar todos" />}
		>
			<div className={styles.incompleteGrid}>
				<span className={styles.classHeader}>Parâmetro</span>
				<span className={styles.classHeader}>Método</span>
				<span className={styles.classHeader}>Unidade</span>
				<span className={styles.classHeader}>Faixa ideal</span>
				{rows.map((row, index) => (
					<div key={row.id} className={styles.incompleteRow}>
						<span className={`${styles.rowLabel} ${styles.incompleteCell}`}>{row.label}</span>
						<FormField error={errors[`${index}.method`]}>
							<FormInput
								aria-label={`${row.label} - método`}
								value={row.method}
								hasError={!!errors[`${index}.method`]}
								onChange={(event) => setField(index, 'method', event.target.value)}
							/>
						</FormField>
						<FormField error={errors[`${index}.unit`]}>
							<FormInput
								aria-label={`${row.label} - unidade`}
								value={row.unit}
								hasError={!!errors[`${index}.unit`]}
								onChange={(event) => setField(index, 'unit', event.target.value)}
							/>
						</FormField>
						{row.idealRange === null ? (
							<span className={`${styles.classEmpty} ${styles.incompleteCell} ${styles.incompleteCellCentered}`}>Definida em cada regra</span>
						) : (
							<FormField error={errors[`${index}.idealRange`]}>
								<FormInput
									aria-label={`${row.label} - faixa ideal`}
									value={row.idealRange}
									hasError={!!errors[`${index}.idealRange`]}
									onChange={(event) => setField(index, 'idealRange', event.target.value)}
								/>
							</FormField>
						)}
					</div>
				))}
			</div>
		</BaseModal>
	);
};
